import React from 'react';

export default function TermsAndConditionsFr() {
  return (
    <div className="doc-page">
      <div className="doc-header">
        <span className="doc-label">Général</span>
        <h1 className="doc-title">Conditions générales d'utilisation de MegaTransact</h1>
        <p className="doc-intro">
          Les règles, responsabilités et conditions qui s'appliquent lorsque vous utilisez
          MegaTransact. MegaTransact est une plateforme numérique commençant par le prêt salarial
          et s'étendant progressivement à des services financiers pratiques. En utilisant
          MegaTransact, vous acceptez d'utiliser la plateforme de manière responsable et
          conformément aux présentes conditions générales.
        </p>
        <div className="doc-meta">
          <span className="doc-meta-item">
            <strong>Date d'entrée en vigueur :</strong> 27 mars 2026
          </span>
          <span className="doc-meta-item">
            <strong>Dernière mise à jour :</strong> 27 mars 2026
          </span>
        </div>
      </div>

      <div className="doc-body">
        <div className="doc-preamble">
          <p>
            Les présentes conditions générales régissent votre accès et votre utilisation de
            MegaTransact, y compris notre application, notre site web, nos canaux de support et
            nos services connexes.
          </p>
          <p>
            En créant un compte, en accédant à MegaTransact ou en utilisant une partie de la
            plateforme, vous acceptez les présentes conditions générales. Si vous n'êtes pas
            d'accord, vous ne devez pas utiliser MegaTransact.
          </p>
        </div>

        {/* Section 1 */}
        <div className="doc-section">
          <span className="section-number">Section 1</span>
          <h2 className="section-title">Qui sommes-nous</h2>
          <p>
            MegaTransact est une plateforme numérique conçue pour fournir un soutien financier
            structuré lié au salaire et des services numériques connexes.
          </p>
          <p>
            Pour toute question concernant les présentes conditions générales, vous pouvez nous
            contacter à :
          </p>
          <div className="doc-contact-box">
            <p>
              <strong>E-mail :</strong>{' '}
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
            <p>
              <strong>Société :</strong> MegaBliss LTD
            </p>
            <p>
              <strong>Adresse :</strong> Bâtiment EIFUN, Avenue Kabalo n° 171, croisement Huilerie-Kabalo, Kinshasa, 4ᵉ niveau, bureau n° 45
            </p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="doc-section">
          <span className="section-number">Section 2</span>
          <h2 className="section-title">Éligibilité</h2>
          <p>
            Pour utiliser MegaTransact, vous devez remplir les conditions d'éligibilité
            applicables au service concerné.
          </p>
          <p>Selon le service, cela peut inclure :</p>
          <ul>
            <li>Avoir l'âge légal pour conclure un accord contraignant</li>
            <li>Fournir des informations exactes et complètes</li>
            <li>
              Être employé par un employeur approuvé ou un partenaire de travail, le cas échéant
            </li>
            <li>
              Satisfaire aux critères d'éligibilité liés au salaire ou spécifiques au service
            </li>
            <li>Utiliser MegaTransact uniquement à des fins licites et légitimes</li>
          </ul>
          <p>
            MegaTransact peut refuser l'accès, suspendre l'intégration ou limiter la disponibilité
            du service lorsque les conditions d'éligibilité ne sont pas remplies.
          </p>
        </div>

        {/* Section 3 */}
        <div className="doc-section">
          <span className="section-number">Section 3</span>
          <h2 className="section-title">Inscription au compte</h2>
          <p>
            Pour utiliser certains services MegaTransact, vous devrez peut-être créer un compte.
          </p>
          <p>Lors de la création et de l'utilisation d'un compte, vous acceptez de :</p>
          <ul>
            <li>Fournir des informations véridiques, exactes et à jour</li>
            <li>Garder vos identifiants de connexion en sécurité</li>
            <li>Maintenir et mettre à jour vos informations si nécessaire</li>
            <li>
              Accepter la responsabilité des activités effectuées via votre compte
            </li>
            <li>
              Notifier MegaTransact rapidement si vous soupçonnez un accès non autorisé ou une
              utilisation abusive
            </li>
          </ul>
          <p>
            MegaTransact n'est pas responsable des pertes résultant de votre incapacité à
            protéger vos identifiants de compte.
          </p>
        </div>

        {/* Section 4 */}
        <div className="doc-section">
          <span className="section-number">Section 4</span>
          <h2 className="section-title">Description des services</h2>
          <p>
            MegaTransact commence par le prêt salarial et peut s'étendre à d'autres services
            financiers pratiques au fil du temps.
          </p>
          <p>Les services peuvent inclure :</p>
          <ul>
            <li>Accès à un soutien financier lié au salaire</li>
            <li>Flux de travail de demande et d'approbation</li>
            <li>Arrangements de remboursement liés à l'employeur</li>
            <li>Support de versement, de remboursement ou de recouvrement</li>
            <li>Outils de gestion de compte</li>
            <li>Outils de communication et de support</li>
            <li>Autres services connexes introduits de temps à autre</li>
          </ul>
          <p>Tous les services ne sont pas disponibles pour tous les utilisateurs à tout moment.</p>
          <p>
            MegaTransact peut ajouter, modifier, suspendre ou interrompre des services sans
            garantir la disponibilité continue d'une fonctionnalité spécifique.
          </p>
        </div>

        {/* Section 5 */}
        <div className="doc-section">
          <span className="section-number">Section 5</span>
          <h2 className="section-title">Conditions de prêt salarial</h2>
          <p>
            Lorsque MegaTransact fournit un accès au prêt salarial, des conditions spécifiques
            supplémentaires peuvent s'appliquer en plus des présentes conditions générales.
          </p>
          <p>En demandant ou en acceptant un soutien salarial via MegaTransact, vous acceptez que :</p>
          <ul>
            <li>Toute demande est soumise à examen et approbation</li>
            <li>L'approbation n'est pas garantie</li>
            <li>
              Tout montant approuvé, durée, structure de remboursement et conditions connexes
              vous seront communiqués avant la finalisation
            </li>
            <li>
              Le remboursement peut être lié au salaire ou à des arrangements soutenus par
              l'employeur, le cas échéant
            </li>
            <li>
              Vous restez responsable du respect de vos obligations de remboursement convenues
            </li>
            <li>
              MegaTransact peut refuser, limiter, suspendre ou annuler l'accès en cas de
              préoccupations liées aux risques, à l'éligibilité, à la conformité ou aux
              opérations
            </li>
          </ul>
          <p>Rien dans les présentes conditions n'oblige MegaTransact à approuver une demande.</p>
        </div>

        {/* Section 6 */}
        <div className="doc-section">
          <span className="section-number">Section 6</span>
          <h2 className="section-title">Informations exactes et vérification</h2>
          <p>
            Vous acceptez de fournir des informations exactes, complètes et non trompeuses à
            tout moment.
          </p>
          <p>
            MegaTransact peut demander des documents, des confirmations ou des détails
            supplémentaires afin de :
          </p>
          <ul>
            <li>Vérifier votre identité</li>
            <li>Confirmer votre emploi ou votre relation professionnelle</li>
            <li>Évaluer l'éligibilité</li>
            <li>Prévenir la fraude ou l'utilisation abusive</li>
            <li>Se conformer aux exigences opérationnelles ou légales</li>
          </ul>
          <p>
            Si vous fournissez des informations fausses, incomplètes, périmées ou trompeuses,
            MegaTransact peut suspendre ou résilier votre accès et peut prendre des mesures
            supplémentaires le cas échéant.
          </p>
        </div>

        {/* Section 7 */}
        <div className="doc-section">
          <span className="section-number">Section 7</span>
          <h2 className="section-title">Arrangements avec l'employeur et le lieu de travail</h2>
          <p>
            Certains services MegaTransact dépendent de la participation de l'employeur ou du
            lieu de travail.
          </p>
          <p>Le cas échéant, vous reconnaissez que :</p>
          <ul>
            <li>
              MegaTransact peut s'appuyer sur les informations reçues des employeurs ou des
              partenaires de travail
            </li>
            <li>
              Les processus liés à l'employeur peuvent affecter l'éligibilité, l'approbation,
              le versement et les arrangements de remboursement
            </li>
            <li>
              La disponibilité du service peut dépendre de la coopération continue entre
              MegaTransact et l'employeur ou le partenaire de travail concerné
            </li>
          </ul>
          <p>
            MegaTransact n'est pas responsable des retards, interruptions ou limitations causés
            par les décisions de l'employeur, le calendrier de paie ou les processus
            administratifs du lieu de travail.
          </p>
        </div>

        {/* Section 8 */}
        <div className="doc-section">
          <span className="section-number">Section 8</span>
          <h2 className="section-title">Frais, charges et obligations de remboursement</h2>
          <p>
            Le cas échéant, MegaTransact communiquera les montants, charges, calendriers de
            remboursement et autres conditions clés pertinents avant qu'un utilisateur ne
            finalise ou n'accepte un service.
          </p>
          <p>Vous acceptez que :</p>
          <ul>
            <li>
              Vous examinerez attentivement les conditions applicables avant d'accepter un
              service
            </li>
            <li>
              Vous êtes responsable du remboursement des montants que vous acceptez valablement
            </li>
            <li>
              Le non-respect des obligations de remboursement peut entraîner des rappels, des
              restrictions, des activités de recouvrement, la suspension de l'accès ou d'autres
              mesures de récupération légales
            </li>
            <li>
              Les obligations impayées peuvent affecter votre éligibilité future aux services
              MegaTransact
            </li>
          </ul>
          <p>
            MegaTransact peut corriger les erreurs évidentes dans les montants affichés, les
            calculs ou le traitement lorsque cela est raisonnablement nécessaire.
          </p>
        </div>

        {/* Section 9 */}
        <div className="doc-section">
          <span className="section-number">Section 9</span>
          <h2 className="section-title">Responsabilités de l'utilisateur</h2>
          <p>Lorsque vous utilisez MegaTransact, vous acceptez de :</p>
          <ul>
            <li>Utiliser la plateforme de manière légale et responsable</li>
            <li>
              Suivre toutes les instructions et processus raisonnablement fournis par
              MegaTransact
            </li>
            <li>Maintenir vos informations à jour</li>
            <li>
              Coopérer aux vérifications et contrôles de sécurité raisonnables
            </li>
            <li>
              Respecter les droits de MegaTransact, de son personnel, de ses partenaires et des
              autres utilisateurs
            </li>
            <li>
              Utiliser la plateforme uniquement pour vos propres fins légitimes, sauf
              autorisation expresse contraire
            </li>
          </ul>
        </div>

        {/* Section 10 */}
        <div className="doc-section">
          <span className="section-number">Section 10</span>
          <h2 className="section-title">Conduite interdite</h2>
          <p>Vous ne devez pas :</p>
          <ul>
            <li>
              Utiliser MegaTransact à des fins illégales, frauduleuses, trompeuses ou abusives
            </li>
            <li>
              Ouvrir ou exploiter des comptes en utilisant de fausses identités ou des
              informations non autorisées
            </li>
            <li>
              Tenter de contourner les contrôles d'éligibilité, de vérification ou de sécurité
            </li>
            <li>
              Interférer avec le fonctionnement, les systèmes ou la sécurité de la plateforme
            </li>
            <li>
              Télécharger du code malveillant, du contenu nuisible ou des matériaux trompeurs
            </li>
            <li>
              Déformer votre emploi, votre salaire, votre capacité de remboursement ou votre
              identité
            </li>
            <li>
              Utiliser MegaTransact d'une manière qui nuit aux autres utilisateurs, employeurs
              ou partenaires
            </li>
            <li>
              Copier, exploiter, désassembler ou utiliser abusivement la plateforme sauf si la
              loi l'autorise
            </li>
          </ul>
          <p>
            MegaTransact peut enquêter sur les comportements suspects et prendre les mesures
            appropriées, y compris la suspension, la résiliation, le signalement ou des mesures
            de récupération le cas échéant.
          </p>
        </div>

        {/* Section 11 */}
        <div className="doc-section">
          <span className="section-number">Section 11</span>
          <h2 className="section-title">Confidentialité</h2>
          <p>
            Votre utilisation de MegaTransact est également soumise à la politique de
            confidentialité de MegaTransact, qui explique comment les informations personnelles
            sont collectées, utilisées, stockées, partagées et protégées.
          </p>
          <p>
            En utilisant MegaTransact, vous reconnaissez que vos informations peuvent être
            traitées conformément à cette politique.
          </p>
        </div>

        {/* Section 12 */}
        <div className="doc-section">
          <span className="section-number">Section 12</span>
          <h2 className="section-title">Fournisseurs et services tiers</h2>
          <p>
            MegaTransact peut s'appuyer sur des fournisseurs tiers pour l'hébergement, la
            vérification, l'analyse, les communications, les versements, le support de
            recouvrement ou des fonctions opérationnelles connexes.
          </p>
          <p>
            MegaTransact peut également s'intégrer aux systèmes des employeurs, aux processus de
            paie, aux canaux de paiement ou aux fournisseurs de services techniques le cas
            échéant.
          </p>
          <p>
            Nous ne sommes pas responsables des services tiers indépendants échappant à notre
            contrôle raisonnable, y compris les défaillances causées par les réseaux tiers, les
            appareils, les pannes de service ou les systèmes de traitement externes.
          </p>
        </div>

        {/* Section 13 */}
        <div className="doc-section">
          <span className="section-number">Section 13</span>
          <h2 className="section-title">Disponibilité du service</h2>
          <p>
            MegaTransact vise à fournir une plateforme fiable, mais nous ne garantissons pas un
            service ininterrompu ou sans erreur à tout moment.
          </p>
          <p>L'accès peut être affecté par :</p>
          <ul>
            <li>La maintenance</li>
            <li>Des problèmes techniques</li>
            <li>Des contrôles de sécurité</li>
            <li>Des pannes tierces</li>
            <li>Des changements réglementaires ou opérationnels</li>
            <li>Des problèmes d'appareil, de réseau ou de connectivité</li>
          </ul>
          <p>
            MegaTransact peut suspendre, restreindre ou retirer l'accès temporairement ou
            définitivement lorsque cela est raisonnablement nécessaire.
          </p>
        </div>

        {/* Section 14 */}
        <div className="doc-section">
          <span className="section-number">Section 14</span>
          <h2 className="section-title">Propriété intellectuelle</h2>
          <p>
            Tout le contenu, l'image de marque, les logiciels, les flux de travail, les designs,
            les textes, les graphiques, les logos et les matériaux de la plateforme mis à
            disposition via MegaTransact sont la propriété de MegaTransact ou de ses concédants
            de licence, sauf indication contraire.
          </p>
          <p>
            Vous ne pouvez utiliser la plateforme que dans le but prévu. Vous ne pouvez pas
            copier, reproduire, distribuer, modifier, vendre ou exploiter les matériaux de
            MegaTransact sans autorisation écrite préalable, sauf si la loi l'autorise.
          </p>
        </div>

        {/* Section 15 */}
        <div className="doc-section">
          <span className="section-number">Section 15</span>
          <h2 className="section-title">Suspension et résiliation</h2>
          <p>
            MegaTransact peut suspendre, restreindre ou résilier votre accès à la plateforme ou à
            des services spécifiques lorsque cela est raisonnablement nécessaire, y compris
            lorsque :
          </p>
          <ul>
            <li>Vous violez les présentes conditions générales</li>
            <li>Vous fournissez des informations fausses ou trompeuses</li>
            <li>Vous ne remplissez pas les conditions d'éligibilité</li>
            <li>Il y a suspicion de fraude, d'utilisation abusive ou de risque de sécurité</li>
            <li>Il y a des obligations impayées ou des litiges non résolus</li>
            <li>
              La poursuite de l'accès n'est pas appropriée sur le plan opérationnel, juridique
              ou commercial
            </li>
          </ul>
          <p>
            Vous pouvez également cesser d'utiliser MegaTransact à tout moment. Cependant,
            l'arrêt de l'utilisation de la plateforme ne supprime pas les obligations déjà nées
            avant la résiliation, y compris les obligations de remboursement.
          </p>
        </div>

        {/* Section 16 */}
        <div className="doc-section">
          <span className="section-number">Section 16</span>
          <h2 className="section-title">Limitation de responsabilité</h2>
          <p>
            Dans toute la mesure permise par la loi applicable, MegaTransact ne sera pas
            responsable des pertes indirectes, accessoires, spéciales, consécutives ou punitives
            découlant de votre utilisation ou de votre incapacité à utiliser la plateforme.
          </p>
          <p>Cela inclut, dans la mesure permise par la loi, les pertes liées à :</p>
          <ul>
            <li>Les retards</li>
            <li>Les interruptions de service</li>
            <li>Les défaillances tierces</li>
            <li>Les opportunités manquées</li>
            <li>La perte de bénéfices</li>
            <li>La perte de données</li>
            <li>Les problèmes d'appareil ou de connectivité</li>
          </ul>
          <p>
            Rien dans les présentes conditions n'exclut la responsabilité qui ne peut légalement
            être exclue.
          </p>
        </div>

        {/* Section 17 */}
        <div className="doc-section">
          <span className="section-number">Section 17</span>
          <h2 className="section-title">Indemnisation</h2>
          <p>
            Vous acceptez d'être responsable des pertes, réclamations, coûts ou dommages
            découlant de votre utilisation abusive de MegaTransact, de votre violation des
            présentes conditions générales ou de votre violation de la loi applicable ou des
            droits d'autrui, dans la mesure permise par la loi.
          </p>
        </div>

        {/* Section 18 */}
        <div className="doc-section">
          <span className="section-number">Section 18</span>
          <h2 className="section-title">Modifications de la plateforme ou des conditions</h2>
          <p>
            MegaTransact peut mettre à jour les présentes conditions générales de temps à autre
            pour refléter les évolutions des services, les exigences légales, les changements
            commerciaux ou les améliorations opérationnelles.
          </p>
          <p>
            Lorsque des modifications importantes sont apportées, MegaTransact peut informer les
            utilisateurs via l'application, le site web, l'e-mail ou d'autres canaux appropriés.
          </p>
          <p>
            Votre utilisation continue de MegaTransact après l'entrée en vigueur des conditions
            mises à jour signifie que vous acceptez les conditions révisées, sauf si la loi
            applicable exige un processus différent.
          </p>
        </div>

        {/* Section 19 */}
        <div className="doc-section">
          <span className="section-number">Section 19</span>
          <h2 className="section-title">Droit applicable</h2>
          <p>
            Les présentes conditions générales sont régies par les lois applicables à MegaBliss
            LTD, sauf si une autre loi est requise par des règles légales obligatoires qui
            s'appliquent à un service ou une relation utilisateur particulière.
          </p>
          <p>
            Tout litige découlant des présentes conditions ou de l'utilisation de MegaTransact
            sera traité devant le tribunal compétent, conformément à la loi applicable.
          </p>
        </div>

        {/* Section 20 */}
        <div className="doc-section">
          <span className="section-number">Section 20</span>
          <h2 className="section-title">Nous contacter</h2>
          <p>
            Si vous avez des questions, des demandes ou des préoccupations concernant les
            présentes conditions générales, veuillez contacter :
          </p>
          <div className="doc-contact-box">
            <p>
              <strong>MegaTransact</strong>
            </p>
            <p>
              <strong>E-mail :</strong>{' '}
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
            <p>
              <strong>Société :</strong> MegaBliss LTD
            </p>
            <p>
              <strong>Adresse :</strong> Bâtiment EIFUN, Avenue Kabalo n° 171, croisement Huilerie-Kabalo, Kinshasa, 4ᵉ niveau, bureau n° 45
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
